module.exports = __webpack_public_path__ + "img/01.a4ebad38.jpg";